import { Component, Fragment } from "react";
import React from 'react';
import { Helmet } from "react-helmet";
import Footer from "../../component/layout/footer";
import Header from "../../component/layout/header";
import PageHeader from "../../component/layout/pageheader";
import { Link } from "react-router-dom";
import Navigate from "../../../../util/Navigate";

const investorsData = [
    {
        name: 'Techstars',
        description: 'Techstars is the world\'s most active pre-seed investor having invested in more than 3,800 companies.',
        imageUrl: '/assets/images/investors/techstarslogo.jpg',
    },
    {
        name: 'HustleFund',
        description: 'Hustle Fund is a venture capital fund investing in hustlers at the pre-seed and seed stages.',
        imageUrl: '/assets/images/investors/hustlefund.jpg',
    },
    {
        name: 'VisibleHands',
        description: 'Visible Hands is the most trusted platform for early-stage, underrepresented founders building high-growth startups.',
        imageUrl: '/assets/images/investors/visiblehands.jpg',
    },
    {
        name: 'Google Black Founders Fund',
        description: 'Designed to help Black-led startups in Europe with up to $150K in capital, Google Cloud credits, and custom support from Google.',
        imageUrl: '/assets/images/investors/blackfoundersfund.jpg',
    },
];

class AboutPage extends Component {
    render() {
        return (
            <>
                <Helmet prioritizeSeoTags>
                    <title>About Glitch</title>
                    <meta
                        name="description"
                        content="Discover how Glitch empowers game developers with innovative, AI-driven marketing solutions. Our mission is to make game marketing easier and more effective."
                    />
                </Helmet>
                <Fragment>
                    <Header />
                    <PageHeader title={'About Us'} curPage={'About Us'} />
                    <section className="glitch-about-section">
                        <div className="container">
                           
                            <div className="glitch-section-wrapper">
                                <div className="glitch-section-intro text-center mb-5">
                                    <h2 className="glitch-section-title">Our Values and Beliefs</h2>
                                    <p className="glitch-section-subtitle">Driving innovation in game marketing</p>
                                </div>
                                
                                <div className="glitch-feature-block row mb-5 align-items-center">
                                    <div className="col-lg-6 glitch-feature-image">
                                        <img src="/assets/images/about/game_marketing_hard.webp" alt="Game Marketing" className="img-fluid rounded shadow-lg" />
                                    </div>
                                    <div className="col-lg-6 glitch-feature-content">
                                        <div className="glitch-feature-icon mb-3">
                                            <i className="fas fa-lightbulb fa-2x text-primary"></i>
                                        </div>
                                        <h2 className="glitch-feature-title">Game Marketing Made Easy with Innovation</h2>
                                        <p className="glitch-feature-text">
                                            Marketing a game is one of the toughest parts of game development, yet it's essential. With over 30,000 games (Steam, Itch, Apple, Android, Console) launching each year, standing out is a challenge.
                                            Traditional marketing approaches are time-consuming, cumbersome, and often leave developers feeling overwhelmed. At Glitch, we believe there's a better way—one that's
                                            easier, simpler, and more effective. Our innovative approach to game marketing unifies influencer outreach, community building, email engagement, playtesting, and showcases into a
                                            seamless "360° product." We empower you to connect meaningfully with your audience, creating lasting, positive outcomes for your game.
                                        </p>
                                        <div className="glitch-feature-cta mt-4">
                                            <Link to={Navigate.homePage()} className="btn btn-primary btn-lg">
                                                Explore Our Solutions <i className="fas fa-arrow-right ms-2"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="glitch-feature-block row mb-5 align-items-center">
                                    <div className="col-lg-6 order-lg-2 glitch-feature-image">
                                        <img src="/assets/images/about/guy_with_blaster.jpg" alt="AI Friend" className="img-fluid rounded shadow-lg" />
                                    </div>
                                    <div className="col-lg-6 order-lg-1 glitch-feature-content">
                                        <div className="glitch-feature-icon mb-3">
                                            <i className="fas fa-trophy fa-2x text-primary"></i>
                                        </div>
                                        <h2 className="glitch-feature-title">Indie Games Marketing Like AAA Games</h2>
                                        <p className="glitch-feature-text">
                                        AAA games have always had an edge over indie games in marketing. However, with advancements in automation tools and distribution strategies, a knowledgeable indie developer—or even an informed solo developer—can achieve marketing success on par with AAA games. Glitch aims to educate and empower these developers to better succeed with their games. Some early results for indie games include but are not limited too:
                                        </p>
                                        <div className="glitch-feature-stats row mt-4">
                                            <div className="col-6">
                                                <div className="glitch-stat-card p-3 text-center bg-dark rounded">
                                                    <h3 className="text-primary">$200k USD</h3>
                                                    <p className="mb-0">In First Month</p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="glitch-stat-card p-3 text-center bg-dark rounded">
                                                    <h3 className="text-primary">37%</h3>
                                                    <p className="mb-0">Wishlist To Sales Conversion</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="glitch-feature-stats row mt-4">
                                            <div className="col-6">
                                                <div className="glitch-stat-card p-3 text-center bg-dark rounded">
                                                    <h3 className="text-primary">3k Wishlist</h3>
                                                    <p className="mb-0">A Day For Games</p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="glitch-stat-card p-3 text-center bg-dark rounded">
                                                    <h3 className="text-primary">$0.19</h3>
                                                    <p className="mb-0">Cost Per Wishlist</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="glitch-feature-block row mb-5 align-items-center">
                                    <div className="col-lg-6 glitch-feature-image">
                                        <img src="/assets/images/about/free-tools.jpg" alt="Free Tools" className="img-fluid rounded shadow-lg" />
                                    </div>
                                    <div className="col-lg-6 glitch-feature-content">
                                        <div className="glitch-feature-icon mb-3">
                                            <i className="fas fa-gift fa-2x text-primary"></i>
                                        </div>
                                        <h2 className="glitch-feature-title">Why We Offer So Many Free Tools</h2>
                                        <p className="glitch-feature-text">
                                            If you've checked out our <Link to={Navigate.publishersToolsPage()} className="text-primary">tools section</Link>, you'll notice we offer a wealth of free resources on game marketing—more than any competitor. Why? First, we genuinely want to see you succeed.
                                            We believe knowledge shouldn't be hoarded. Second, we want you to trust our expertise and our results, and working with us should feel natural, not forced. Third, we believe informed developers
                                            make better decisions about marketing, whether they choose to DIY or work with a partner. For us, it's all about transparency, honesty, and putting your success first.
                                        </p>
                                        <div className="glitch-feature-badge mt-4">
                                            <span className="badge bg-primary me-2"><i className="fas fa-check-circle me-1"></i> Free Resources</span>
                                            <span className="badge bg-primary me-2"><i className="fas fa-check-circle me-1"></i> No Hidden Costs</span>
                                            <span className="badge bg-primary"><i className="fas fa-check-circle me-1"></i> Community Focused</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="glitch-investors-section mt-5 pt-5">
                                    <div className="glitch-section-header text-center mb-5">
                                        <h2 className="glitch-section-title">Our Investors and Funders</h2>
                                        <p className="glitch-section-subtitle">Backed by industry leaders who believe in our vision</p>
                                    </div>
                                    <div className="row">
                                        {investorsData.map((investor, index) => (
                                            <div key={index} className="col-lg-6 mb-4">
                                                <div className="glitch-investor-card p-4 rounded bg-dark h-100">
                                                    <div className="d-flex align-items-start">
                                                        <div className="glitch-investor-logo me-4">
                                                            <img src={investor.imageUrl} alt={investor.name} className="rounded-circle shadow" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                                                        </div>
                                                        <div className="glitch-investor-details">
                                                            <h3 className="glitch-investor-name">{investor.name}</h3>
                                                            <p className="glitch-investor-description mb-0">{investor.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Footer />
                </Fragment>
            </>
        );
    }
}

export default AboutPage;